import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Float = props => {
  var {
    Float: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Float');
  return null;
};
Float.displayName = 'JVR.Float';